import './aos-config.component.js';
import './titles-animations.component.js';
/*import './btn-corner-outline-animation.component.js';*/
/*import './card-fill.component.js';
import './btn-fill.component.js';*/
import './btn-roll.component.js';
import './sticky-btn.component.js';
/*import './cursor.component.js';*/

import './stroke.component.js';
import './universal-roll.component.js';
import './logo-hover.component.js';
import './image-webgl-hover.component.js';
import './sigil-figure.component.js';
